import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconBookmarkRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.802 4A.816.816 0 0 0 5 4.826V19.17c0 .634.666 1.031 1.2.717l5.401-3.202a.77.77 0 0 1 .798 0l5.4 3.202c.535.318 1.201-.079 1.201-.717V4.826A.816.816 0 0 0 18.198 4H5.802Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconBookmarkRoundLine);
export default Memo;
